// Shared i18next options for both the server (fs backend) and client (http backend) instances

const isSSR = typeof window === 'undefined';

const nodeEnv = isSSR ? process.env.NODE_ENV : window.ENV.NODE_ENV;

const isDev = nodeEnv === 'development';

export const i18nextOptions = {
  supportedLngs: ['en', 'de'],
  fallbackLng: 'en',
  react: { useSuspense: false },
  debug: !isSSR && isDev,
};
